// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3aI1y","overflowing":"ReadFullNote_overflowing__1kYQ9"};